/*------------------------------------------------------------------
Please read!
------------------------------------------------------------------*/

/*
This file is a symlink to the blocks.js file in the app folder,
making changes here affects subsites that are using the blocks.js
*/

/*------------------------------------------------------------------
Import the block scripts
------------------------------------------------------------------*/

function loadReactiveScripts() {
  // Import the blocks
  console.log("%cblocks", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #f7ebde");
  // Add the script's path and the element selector, they will be imported on demand when the element is added to the page
  ReactiveLoader({
    './blocks/default/accordion': '.js-default-accordion',
    './blocks/default/slider': '.js-default-slider',
    './blocks/default/gallery': '.js-default-gallery',
    './blocks/default/testimonial': '.js-default-testimonial',
    './blocks/default/visual-planner': '.js-default-visual-planner',
    './blocks/default/conditional-link': '.js-default-conditional-link',
    './blocks/default/faqs': '.js-default-faqs',
    './blocks/carousel/link': '.js-carousel-link',
    './blocks/hero/media-text': '.js-hero-media-text'
  });
}

// Initialize the block watchers when the document is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadReactiveScripts);
} else {
  loadReactiveScripts();
}